export default "__VITE_ASSET__1b7ceb82__"